import { render, staticRenderFns } from "./RouteSet.vue?vue&type=template&id=67673436&"
import script from "./RouteSet.vue?vue&type=script&lang=js&"
export * from "./RouteSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports